// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__qlg0t","title":"Images45_title__1Uamm","images":"Images45_images__YfRDN"};